import { cx } from "./cx";

const DROP =
  "M17.3 2.9c1.1.2 7.9 8.1 10.1 13.5 2.7 6.7-2.8 12.7-9.5 13.1-6.8.4-13.6-3.4-13.7-10.2C4.1 13.5 14.8 2.4 17.3 2.9Z";
const WINGS = "M15.2 17.8c-3.8-.5-5.9-2.4-5.2-4 .9-2 4.4-.6 5.2 4Zm1.6 0c3.8-.5 5.9-2.4 5.2-4-.9-2-4.4-.6-5.2 4Z";
const BODY_AND_LEGS = "M16 17.4v6.1m-.8-4.8-2.2 1m3.8-1 2.2 1m-3.8 1.6-1.7 1.5m3.3-1.5 1.7 1.5";

// The same drawing as apps/web/public/amber.svg and amber-mark.svg (docs/design/brand).
function Insect({ color }: { color: string }) {
  return (
    <g transform="rotate(-30 16 19)">
      <path d={WINGS} fill={color} />
      <circle cx="16" cy="15.3" r="1.1" fill={color} />
      <path d={BODY_AND_LEGS} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </g>
  );
}

export function Mark({ filled = false, className }: { filled?: boolean; className?: string }) {
  if (filled) {
    return (
      <svg viewBox="0 0 32 32" aria-hidden="true" fill="none" className={className}>
        <path d={DROP} fill="#e0a03a" stroke="#875000" strokeWidth="1.5" strokeLinejoin="round" />
        <Insect color="#4d300d" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" fill="none" className={cx("text-fg", className)}>
      <path d={DROP} stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
      <Insect color="currentColor" />
    </svg>
  );
}
